import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import logger from './logger';

export function createAppInsightsClient() {
  const connectionString = process.env.APPLICATIONINSIGHTS_CONNECTION_STRING;
  let appInsightsConfigured = false;
  let appInsights = null;

  if (connectionString && connectionString.length > 0) {
      appInsights = new ApplicationInsights({
        config: {
          connectionString: connectionString,
          enableAutoRouteTracking: true
        }
      });

      try {
        appInsights.loadAppInsights();
        appInsightsConfigured = true;
      } catch (error) {
        logger.error(`Application Insights client not properly initialized. : ${error}`);
      }
  }

  const client = {
    trackTrace: (options) => {
      if (appInsightsConfigured) {
        appInsights.trackTrace({ message: options.message, severityLevel: options.severityLevel, properties: options.properties });
      } else {
        logger.error(options.message);
      }
    }
  };

  return client;
}
